import { helper } from '@ember/component/helper';

const matchDelimiter = /[\s,]+/gm;

export default helper(function hasBlocksHelper(blockKeyValues, { noBlock = {} }) {
  if (typeof noBlock === 'string') {
    const blocks = noBlock.split(matchDelimiter);
    noBlock = {};
    for (let i = 0; i < blocks.length; ++i) {
      const block = blocks[i].trim();
      if (block) {
        noBlock[block[i]] = true;
      }
    }
  }
  const blocks = {};
  let isNotEmpty = false;
  for (let i = 0; i < blockKeyValues.length; i += 2) {
    const block = blockKeyValues[i];
    const hasBlock = blockKeyValues[i + 1] && !noBlock[block];
    blocks[block] = hasBlock;
    isNotEmpty ||= hasBlock;
  }
  blocks.isNotEmpty = isNotEmpty;
  blocks.isEmpty = !isNotEmpty;
  blocks.noBlock = noBlock;
  return blocks;
});
